import axios from '@plugins/axios'
import config from '@src/app.config'
const env = config.env
const appConfig = config[env]

// const serverUrl = appConfig.server_url

export const state = {
  aAndBData: [
    {
      domainId: 1,
      domain: 'Liderazgo y relaciones sociales en el trabajo',
      dimension: 'Características del liderazgo',
      withoutRisk: {
        number: 7,
        percentage: 11.7,
      },
      lowRisk: {
        number: 8,
        percentage: 13.3,
      },
      middleRisk: {
        number: 14,
        percentage: 23.3,
      },
      highRisk: {
        number: 17,
        percentage: 28.3,
      },
      veryHighRisk: {
        number: 14,
        percentage: 23.3,
      },
    },
    {
      domainId: 1,
      domain: 'Liderazgo y relaciones sociales en el trabajo',
      dimension: 'Relaciones sociales en el trabajo',
      withoutRisk: {
        number: 8,
        percentage: 13.3,
      },
      lowRisk: {
        number: 13,
        percentage: 21.7,
      },
      middleRisk: {
        number: 16,
        percentage: 26.7,
      },
      highRisk: {
        number: 13,
        percentage: 21.7,
      },
      veryHighRisk: {
        number: 10,
        percentage: 16.7,
      },
    },
    {
      domainId: 1,
      domain: 'Liderazgo y relaciones sociales en el trabajo',
      dimension: 'Retroalimentación del desempeño',
      withoutRisk: {
        number: 6,
        percentage: 10,
      },
      lowRisk: {
        number: 9,
        percentage: 15,
      },
      middleRisk: {
        number: 7,
        percentage: 11.7,
      },
      highRisk: {
        number: 19,
        percentage: 31.7,
      },
      veryHighRisk: {
        number: 19,
        percentage: 31.7,
      },
    },
    {
      domainId: 1,
      domain: 'Liderazgo y relaciones sociales en el trabajo',
      dimension: 'Relación con los colaboradores',
      withoutRisk: {
        number: 0,
        percentage: 0,
      },
      lowRisk: {
        number: 4,
        percentage: 44.4,
      },
      middleRisk: {
        number: 1,
        percentage: 11.1,
      },
      highRisk: {
        number: 1,
        percentage: 11.1,
      },
      veryHighRisk: {
        number: 3,
        percentage: 33.3,
      },
    },
    {
      domainId: 1,
      domain: 'Liderazgo y relaciones sociales en el trabajo',
      isTotal: true,
      withoutRisk: {
        number: 4,
        percentage: 6.7,
      },
      lowRisk: {
        number: 11,
        percentage: 18.3,
      },
      middleRisk: {
        number: 16,
        percentage: 26.7,
      },
      highRisk: {
        number: 19,
        percentage: 31.7,
      },
      veryHighRisk: {
        number: 10,
        percentage: 16.7,
      },
    },

    {
      domainId: 2,
      domain: 'Control sobre el trabajo',
      dimension: 'Claridad de rol',
      withoutRisk: {
        number: 4,
        percentage: 6.7,
      },
      lowRisk: {
        number: 11,
        percentage: 18.3,
      },
      middleRisk: {
        number: 16,
        percentage: 26.7,
      },
      highRisk: {
        number: 19,
        percentage: 31.7,
      },
      veryHighRisk: {
        number: 10,
        percentage: 16.7,
      },
    },
    {
      domainId: 2,
      domain: 'Control sobre el trabajo',
      dimension: 'Capacitación',
      withoutRisk: {
        number: 8,
        percentage: 13.3,
      },
      lowRisk: {
        number: 13,
        percentage: 21.7,
      },
      middleRisk: {
        number: 16,
        percentage: 26.7,
      },
      highRisk: {
        number: 13,
        percentage: 21.7,
      },
      veryHighRisk: {
        number: 10,
        percentage: 16.7,
      },
    },
    {
      domainId: 2,
      domain: 'Control sobre el trabajo',
      dimension: 'Participación y manejo del cambio',
      withoutRisk: {
        number: 6,
        percentage: 10,
      },
      lowRisk: {
        number: 9,
        percentage: 15,
      },
      middleRisk: {
        number: 7,
        percentage: 11.7,
      },
      highRisk: {
        number: 19,
        percentage: 31.7,
      },
      veryHighRisk: {
        number: 19,
        percentage: 31.7,
      },
    },
    {
      domainId: 2,
      domain: 'Control sobre el trabajo',
      dimension:
        'Oportunidades para el uso y desarrollo de habilidades y conocimientos',
      withoutRisk: {
        number: 0,
        percentage: 0,
      },
      lowRisk: {
        number: 4,
        percentage: 44.4,
      },
      middleRisk: {
        number: 1,
        percentage: 11.1,
      },
      highRisk: {
        number: 1,
        percentage: 11.1,
      },
      veryHighRisk: {
        number: 3,
        percentage: 33.3,
      },
    },
    {
      domainId: 2,
      domain: 'Control sobre el trabajo',
      dimension: 'Control y autonomía sobre el trabajo',
      withoutRisk: {
        number: 0,
        percentage: 0,
      },
      lowRisk: {
        number: 4,
        percentage: 44.4,
      },
      middleRisk: {
        number: 1,
        percentage: 11.1,
      },
      highRisk: {
        number: 1,
        percentage: 11.1,
      },
      veryHighRisk: {
        number: 3,
        percentage: 33.3,
      },
    },
    {
      domainId: 2,
      domain: 'Control sobre el trabajo',
      isTotal: true,
      withoutRisk: {
        number: 4,
        percentage: 6.7,
      },
      lowRisk: {
        number: 11,
        percentage: 18.3,
      },
      middleRisk: {
        number: 16,
        percentage: 26.7,
      },
      highRisk: {
        number: 19,
        percentage: 31.7,
      },
      veryHighRisk: {
        number: 10,
        percentage: 16.7,
      },
    },

    {
      domainId: 3,
      domain: 'Demandas del trabajo',
      dimension: 'Demandas ambientales y de esfuerzo físico',
      withoutRisk: {
        number: 4,
        percentage: 6.7,
      },
      lowRisk: {
        number: 11,
        percentage: 18.3,
      },
      middleRisk: {
        number: 16,
        percentage: 26.7,
      },
      highRisk: {
        number: 19,
        percentage: 31.7,
      },
      veryHighRisk: {
        number: 10,
        percentage: 16.7,
      },
    },
    {
      domainId: 3,
      domain: 'Demandas del trabajo',
      dimension: 'Demandas emocionales',
      withoutRisk: {
        number: 8,
        percentage: 13.3,
      },
      lowRisk: {
        number: 13,
        percentage: 21.7,
      },
      middleRisk: {
        number: 16,
        percentage: 26.7,
      },
      highRisk: {
        number: 13,
        percentage: 21.7,
      },
      veryHighRisk: {
        number: 10,
        percentage: 16.7,
      },
    },
    {
      domainId: 3,
      domain: 'Demandas del trabajo',
      dimension: 'Demandas cuantitativas',
      withoutRisk: {
        number: 6,
        percentage: 10,
      },
      lowRisk: {
        number: 9,
        percentage: 15,
      },
      middleRisk: {
        number: 7,
        percentage: 11.7,
      },
      highRisk: {
        number: 19,
        percentage: 31.7,
      },
      veryHighRisk: {
        number: 19,
        percentage: 31.7,
      },
    },
    {
      domainId: 3,
      domain: 'Demandas del trabajo',
      dimension: 'Influencia del trabajo sobre el entorno extralaboral',
      withoutRisk: {
        number: 0,
        percentage: 0,
      },
      lowRisk: {
        number: 4,
        percentage: 44.4,
      },
      middleRisk: {
        number: 1,
        percentage: 11.1,
      },
      highRisk: {
        number: 1,
        percentage: 11.1,
      },
      veryHighRisk: {
        number: 3,
        percentage: 33.3,
      },
    },
    {
      domainId: 3,
      domain: 'Demandas del trabajo',
      dimension: 'Exigencias de responsabilidad del cargo',
      withoutRisk: {
        number: 0,
        percentage: 0,
      },
      lowRisk: {
        number: 4,
        percentage: 44.4,
      },
      middleRisk: {
        number: 1,
        percentage: 11.1,
      },
      highRisk: {
        number: 1,
        percentage: 11.1,
      },
      veryHighRisk: {
        number: 3,
        percentage: 33.3,
      },
    },
    {
      domainId: 3,
      domain: 'Demandas del trabajo',
      dimension: 'Demandas de carga mental',
      withoutRisk: {
        number: 4,
        percentage: 6.7,
      },
      lowRisk: {
        number: 11,
        percentage: 18.3,
      },
      middleRisk: {
        number: 16,
        percentage: 26.7,
      },
      highRisk: {
        number: 19,
        percentage: 31.7,
      },
      veryHighRisk: {
        number: 10,
        percentage: 16.7,
      },
    },
    {
      domainId: 3,
      domain: 'Demandas del trabajo',
      dimension: 'Consistencia del rol',
      withoutRisk: {
        number: 8,
        percentage: 13.3,
      },
      lowRisk: {
        number: 13,
        percentage: 21.7,
      },
      middleRisk: {
        number: 16,
        percentage: 26.7,
      },
      highRisk: {
        number: 13,
        percentage: 21.7,
      },
      veryHighRisk: {
        number: 10,
        percentage: 16.7,
      },
    },
    {
      domainId: 3,
      domain: 'Demandas del trabajo',
      dimension: 'Demandas de la jornada de trabajo',
      withoutRisk: {
        number: 8,
        percentage: 13.3,
      },
      lowRisk: {
        number: 13,
        percentage: 21.7,
      },
      middleRisk: {
        number: 16,
        percentage: 26.7,
      },
      highRisk: {
        number: 13,
        percentage: 21.7,
      },
      veryHighRisk: {
        number: 10,
        percentage: 16.7,
      },
    },
    {
      domainId: 3,
      domain: 'Demandas del trabajo',
      isTotal: true,
      withoutRisk: {
        number: 4,
        percentage: 6.7,
      },
      lowRisk: {
        number: 11,
        percentage: 18.3,
      },
      middleRisk: {
        number: 16,
        percentage: 26.7,
      },
      highRisk: {
        number: 19,
        percentage: 31.7,
      },
      veryHighRisk: {
        number: 10,
        percentage: 16.7,
      },
    },

    {
      domainId: 4,
      domain: 'Recompensas',
      dimension:
        'Recompensas derivadas de la pertenencia a la organización y del trabajo que se realiza',
      withoutRisk: {
        number: 0,
        percentage: 0,
      },
      lowRisk: {
        number: 4,
        percentage: 44.4,
      },
      middleRisk: {
        number: 1,
        percentage: 11.1,
      },
      highRisk: {
        number: 1,
        percentage: 11.1,
      },
      veryHighRisk: {
        number: 3,
        percentage: 33.3,
      },
    },
    {
      domainId: 4,
      domain: 'Recompensas',
      dimension: 'Reconocimiento y compensación',
      withoutRisk: {
        number: 4,
        percentage: 6.7,
      },
      lowRisk: {
        number: 11,
        percentage: 18.3,
      },
      middleRisk: {
        number: 16,
        percentage: 26.7,
      },
      highRisk: {
        number: 19,
        percentage: 31.7,
      },
      veryHighRisk: {
        number: 10,
        percentage: 16.7,
      },
    },

    {
      domainId: 4,
      domain: 'Recompensas',
      isTotal: true,
      withoutRisk: {
        number: 4,
        percentage: 6.7,
      },
      lowRisk: {
        number: 11,
        percentage: 18.3,
      },
      middleRisk: {
        number: 16,
        percentage: 26.7,
      },
      highRisk: {
        number: 19,
        percentage: 31.7,
      },
      veryHighRisk: {
        number: 10,
        percentage: 16.7,
      },
    },
    {
      general: 'Factores de Riesgo Psicosocial Intralaboral',
      isTotalGeneral: true,
      withoutRisk: {
        number: 5,
        percentage: 8.3,
      },
      lowRisk: {
        number: 9,
        percentage: 15,
      },
      middleRisk: {
        number: 10,
        percentage: 16.7,
      },
      highRisk: {
        number: 13,
        percentage: 21.7,
      },
      veryHighRisk: {
        number: 23,
        percentage: 38.3,
      },
    },
  ],
}

export const mutations = {
}

export const getters = {
  aAndBData: (state) => state.aAndBData
}

export const actions = {}